"use strict";
/* PERF 15SEP2026: reescrito sin jQuery (misma lógica, mismos data-attributes y clases). */
(function () {
	const data = (el, k) => window.hmpData(el, k);
	const setData = (el, k, v) => window.hmpSetData(el, k, v);
	const closestPopup = (el) => (el && el.closest ? el.closest(".popup") : null);
	const asEl = (ctx, e) => (e instanceof Event ? ctx : e);

	// delegación de eventos tipo $(document).on("click", selector, fn)
	const delegate = (type, selector, handler) => {
		document.addEventListener(type, function (event) {
			const match = event.target.closest(selector);
			if (match) handler.call(match, event);
		});
	};

	const ANIM_END = "animationend";

	const adpPopup = {
		sPrevious: window.scrollY,
		sDirection: "down",
		_eventsBound: false,

		init: function () {
			adpPopup.popupInit();
			if (!adpPopup._eventsBound) {
				adpPopup._eventsBound = true;
				adpPopup.events();
			}
		},

		events: function () {
			delegate("click", ".popup-close", adpPopup.closePopup);
			delegate("click", ".popup-accept", adpPopup.acceptPopup);
			delegate("click", ".popup-accept", adpPopup.closePopup);
			delegate("click", ".age-verification__popup-close", adpPopup.agePopup);
			delegate("click", ".age-verification__popup-close", adpPopup.closePopup);
			delegate("click", ".age-verification__button-no", adpPopup.ageDeclined);

			document.addEventListener("keyup", function (e) {
				if (e.key === "Escape") {
					document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach((p) => adpPopup.closePopup(p));
				}
				if (e.key === "F4") {
					document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach((p) => adpPopup.closePopup(p));
				}
			});

			delegate("click", ".popup-overlay", function () {
				document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach((p) => adpPopup.closePopup(p));
			});

			document.addEventListener("scroll", function () {
				const scrollCurrent = window.scrollY;
				adpPopup.sDirection = scrollCurrent > adpPopup.sPrevious ? "down" : "up";
				adpPopup.sPrevious = scrollCurrent;
			}, { passive: true });
		},

		popupInit: function () {
			document.querySelectorAll(".popup").forEach((popup) => {
				if (popup._hmpPopupInit) return;
				popup._hmpPopupInit = true;

				if ("manual" === data(popup, "open-trigger")) {
					const selector = data(popup, "open-manual-selector");
					if (selector) {
						document.querySelectorAll(selector).forEach((el) => el.classList.add("popup-trigger"));
						delegate("click", selector, function (e) {
							e.preventDefault();
							popup.classList.remove("popup-already-opened");
							adpPopup.openPopup(popup);
							if (e.currentTarget && e.currentTarget.classList && e.currentTarget.classList.contains("popup")) {
								adpPopup.closePopup(document.querySelector(selector));
							}
						});
					}
				}

				if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains("age-verification")) return;

				adpPopup.openTriggerPopup(popup);
			});
		},

		openTriggerPopup: function (e) {
			const popup = asEl(this, e);
			const trigger = data(popup, "open-trigger");

			if ("none" === trigger) {
				const ageVerification = adpPopup.getStorage("popup-age-" + data(popup, "id") || 0);
				if (!ageVerification) adpPopup.openPopup(popup);
			}

			if ("delay" === trigger) {
				setTimeout(() => adpPopup.openPopup(popup), (Number(data(popup, "open-delay-number")) || 0) * 1000);
			}

			if ("exit" === trigger) {
				let showExit = true;
				document.addEventListener("mousemove", function (ev) {
					const scroll = window.pageYOffset || document.documentElement.scrollTop;
					if (ev.pageY - scroll < 7 && showExit) {
						adpPopup.openPopup(popup);
						showExit = false;
					}
				});
			}

			if ("scroll" === trigger) {
				const pointScrollType = data(popup, "open-scroll-type");
				const pointScrollPosition = Number(data(popup, "open-scroll-position"));
				document.addEventListener("scroll", function () {
					if ("px" === pointScrollType && window.scrollY >= pointScrollPosition) adpPopup.openPopup(popup);
					if ("%" === pointScrollType && adpPopup.getScrollPercent() >= pointScrollPosition) adpPopup.openPopup(popup);
				}, { passive: true });
			}

			if ("accept" === trigger) {
				const accept = adpPopup.getStorage("popup-accept-" + data(popup, "id") || 0);
				if (!accept) adpPopup.openPopup(popup);
			}
		},

		closeTriggerPopup: function (e) {
			const popup = asEl(this, e);
			const trigger = data(popup, "close-trigger");

			if ("delay" === trigger) {
				setTimeout(() => adpPopup.closePopup(popup), (Number(data(popup, "close-delay-number")) || 0) * 1000);
			}

			if ("scroll" === trigger) {
				const pointScrollType = data(popup, "close-scroll-type");
				const pointScrollPosition = Number(data(popup, "close-scroll-position"));
				const initScrollPx = Number(data(popup, "init-scroll-px"));
				const initScrollPercent = Number(data(popup, "init-scroll-percent"));

				document.addEventListener("scroll", function () {
					if ("px" === pointScrollType) {
						if ("up" === adpPopup.sDirection && window.scrollY < initScrollPx - pointScrollPosition) adpPopup.closePopup(popup);
						if ("down" === adpPopup.sDirection && window.scrollY >= initScrollPx + pointScrollPosition) adpPopup.closePopup(popup);
					}
					if ("%" === pointScrollType) {
						const pct = adpPopup.getScrollPercent();
						if ("up" === adpPopup.sDirection && pct < initScrollPercent - pointScrollPosition) adpPopup.closePopup(popup);
						if ("down" === adpPopup.sDirection && pct >= initScrollPercent + pointScrollPosition) adpPopup.closePopup(popup);
					}
				}, { passive: true });
			}
		},

		openPopup: function (e) {
			const popup = asEl(this, e);
			if (!popup) return;

			if (popup.matches('[data-body-scroll-disable="true"]')) {
				document.body.classList.add("popup-scroll-hidden");
			}

			const id = data(popup, "id");
			const limit = parseInt(adpPopup.getStorage("popup-" + id) || 0) + 1;
			adpPopup.setStorage("popup-" + id, limit, { expires: data(popup, "limit-lifetime") });

			if (popup.classList.contains("popup-open")) return;
			if (popup.classList.contains("popup-already-opened")) return;

			popup.classList.add("popup-open");
			setData(popup, "init-scroll-px", window.scrollY);
			setData(popup, "init-scroll-percent", adpPopup.getScrollPercent());

			adpPopup.applyAnimation(popup, data(popup, "open-animation"));
			adpPopup.closeTriggerPopup(popup);
		},

		agePopup: function (e) {
			const popup = closestPopup(asEl(this, e));
			if (!popup) return;
			adpPopup.setStorage("popup-age-" + data(popup, "id"), 1, { expires: 360 });
		},

		ageDeclined: function () {
			document.querySelectorAll(".age-verification__question").forEach((el) => el.classList.remove("show"));
			document.querySelectorAll(".age-verification__declined").forEach((el) => el.classList.add("show"));
		},

		acceptPopup: function (e) {
			const popup = closestPopup(asEl(this, e));
			if (!popup) return;
			adpPopup.setStorage("popup-accept-" + data(popup, "id"), 1, { expires: 360 });
		},

		closePopup: function (e) {
			const popup = closestPopup(asEl(this, e));
			if (!popup) return;
			adpPopup.applyAnimation(popup, data(popup, "exit-animation"), function () {
				popup.classList.add("popup-already-opened");
				popup.classList.remove("popup-open");
				document.body.classList.remove("popup-scroll-hidden");
			});
		},

		isAllowPopup: function (e) {
			const popup = asEl(this, e);
			const limitDisplay = parseInt(data(popup, "limit-display") || 0);
			const limitDisplayCookie = parseInt(adpPopup.getStorage("popup-" + data(popup, "id")));
			if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) return;
			return true;
		},

		applyAnimation: function (el, name, callback) {
			const popup = closestPopup(el);
			if (!popup) return;
			const overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

			const overlay = popup.nextElementSibling && popup.nextElementSibling.classList.contains("popup-overlay") ? popup.nextElementSibling : null;
			if (overlay) {
				overlay.classList.add("popup-animated", overlayName);
				overlay.addEventListener(ANIM_END, function h() {
					overlay.classList.remove("popup-animated", overlayName);
				}, { once: true });
			}

			const wrap = popup.querySelector(".popup-wrap");
			const cls = (name || "").split(" ").filter(Boolean);
			if (wrap) {
				wrap.classList.add("popup-animated", ...cls);
				let done = false;
				const finish = () => {
					if (done) return; done = true;
					wrap.classList.remove("popup-animated", ...cls);
					if (typeof callback === "function") callback();
				};
				wrap.addEventListener(ANIM_END, finish, { once: true });
				// red de seguridad si no hay animación CSS definida
				setTimeout(finish, 1200);
			} else if (typeof callback === "function") {
				callback();
			}
		},

		getCookie: function (name) {
			const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		},

		setCookie: function (name, value, options) {
			options = options || {};
			options.path = options.hasOwnProperty("path") ? options.path : "/";
			options.expires = parseInt(options.expires);
			if (typeof options.expires == "number" && options.expires) {
				options.expires = new Date(new Date().setDate(new Date().getDate() + options.expires)).toUTCString();
			}
			let updatedCookie = name + "=" + encodeURIComponent(value);
			for (const propName in options) {
				updatedCookie += "; " + propName;
				if (options[propName] !== true) updatedCookie += "=" + options[propName];
			}
			document.cookie = updatedCookie;
		},

		getStorage: function (key) {
			let item;
			try { item = localStorage.getItem(key); } catch (e) { return undefined; }
			if (!item) return undefined;
			try {
				const parsed = JSON.parse(item);
				if (parsed.expires && Date.now() > parsed.expires) { localStorage.removeItem(key); return undefined; }
				return parsed.value;
			} catch (e) { return undefined; }
		},

		setStorage: function (key, value, options = {}) {
			const payload = { value, expires: null };
			if (options.expires) {
				const d = new Date();
				d.setDate(d.getDate() + parseInt(options.expires, 10));
				payload.expires = d.getTime();
			}
			try { localStorage.setItem(key, JSON.stringify(payload)); } catch (e) {}
		},

		getScrollPercent: function () {
			const h = document.documentElement, b = document.body;
			return ((h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100;
		},
	};

	const boot = () => adpPopup.init();
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
	else boot();
	document.addEventListener("shopify:section:load", boot);
	document.addEventListener("shopify:section:unload", () => document.body.classList.remove("popup-scroll-hidden"));
	window.adpPopup = adpPopup;
})();
